class SectionSoftwareDownload {
  constructor () {
    this.softItems = document.querySelectorAll('.SD__software-item')
    this.softCardItems = document.querySelectorAll('.SD__software-item-card')
    this.devicesCheckboxs = document.querySelectorAll(
      '.SD__left-select-item-input'
    )
    this.modals = document.querySelectorAll('.SD__software-info-modal')
    this.closeModalBtns = document.querySelectorAll(
      '.SD__software-info-modal-content-close'
    )
    this.emptyNotice = document.querySelectorAll('.SD__software--empty')
    this.filterBtnMobile = document.querySelector('.SD__filter-btn')
    this.filterBtnSubmenu = document.querySelector('.SD__toggle-btn')
    this.selectedSeries = [] // 已选择的系列

    this.init()
  }

  init () {
    this.initSupportedDevices()
    this.initModal()
    this.initFilterBtnMobile()

    window.addEventListener('scroll', () => {
      this.calcLeftStickyTop()
    })
  }

  // 解析hash参数
  parseHashParams () {
    const hash = window.location.hash
    if (!hash) {
      return
    }
    const hashDom = document.querySelector(hash)
    if (hashDom) {
      hashDom.querySelector('.SD__software-item-card').click()
    }
  }

  // 支持的设备、系列
  initSupportedDevices () {
    // 监听checkbox变化
    this.devicesCheckboxs.forEach(device => {
      device.addEventListener('change', () => {
        // 获取已选择的系列
        this.selectedSeriesVal = Array.from(this.devicesCheckboxs)
          .filter(checkbox => checkbox.checked)
          .map(checkbox => checkbox.value)

        // 找到需要显示的dom
        const activeItems = Array.from(this.softItems).filter(item => {
          const itemSupportedSeries = item.dataset.supportedSeries.split(',')
          // || _item === 'all-3d-scanners'
          if (
            this.selectedSeriesVal.includes('accessories') &&
            this.selectedSeriesVal.length === 1
          ) {
            return itemSupportedSeries.some(_item =>
              this.selectedSeriesVal.includes(_item)
            )
          } else {
            return itemSupportedSeries.some(
              _item =>
                this.selectedSeriesVal.includes(_item) ||
                _item === 'all-3d-scanners'
            )
          }
        })
        // console.log(
        //   `%c>> $activeItems`,
        //   'color:yellow',
        //   `checkbox: ${this.selectedSeriesVal}`,
        //   `符合条件的activeItems: ${activeItems}, ${activeItems.length}`
        // )

        // 如果未选择任何系列，则显示所有软件
        if (this.selectedSeriesVal.length === 0) {
          this.emptyNotice.forEach(item => {
            item.classList.remove('active')
          })
          this.toggleAllSoftItems('show')
          return
        }

        this.toggleAllSoftItems()
        Array.from(activeItems).forEach(item => {
          item.classList.add('active')
        })
        this.checkItemsDisplay()

        this.scrollToTarget()
      })
    })
  }

  // 滚动到指定盒子
  scrollToTarget () {
    // const target = document.querySelector('.SD__right')
    // const targetRect = target.getBoundingClientRect()
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  // 监听子元素 display 的变化
  checkItemsDisplay () {
    const SDRightContents = document.querySelectorAll('.SD__right-content')
    SDRightContents.forEach(content => {
      const softItems = content.querySelectorAll('.SD__software-item')
      const emptyNotice = content.querySelector('.SD__software--empty')

      // console.log(`%c>> $softItems`, 'color:yellow', softItems)
      // console.log(`%c>> $emptyNotice`, 'color:yellow', emptyNotice)

      // 判断 softItems 是否 都是display: none
      const allDisplay = Array.from(softItems).map(
        item => item.style.display || window.getComputedStyle(item).display
      )
      const allDisplayNone = allDisplay.every(item => item === 'none')

      // for (const item of softItems) {
      //   console.log(
      //     `%c>> $item.style.display`,
      //     'color:yellow',
      //     item.style.display,
      //     item
      //   )
      // }

      // console.log(`%c>> $allDisplayNone`, 'color:yellow', allDisplayNone)
      if (allDisplayNone) {
        console.log(`%c>> $allDisplayNone`, 'color:yellow', 1)
        emptyNotice.classList.add('active')
      } else {
        console.log(`%c>> $allDisplayNone`, 'color:yellow', 2)
        emptyNotice.classList.remove('active')
      }
    })
  }

  // 隐藏/显示所有 this.softItems
  toggleAllSoftItems (status = 'hide') {
    Array.from(this.softItems).forEach(item => {
      if (status === 'hide') {
        item.classList.remove('active')
      } else if (status === 'show') {
        item.classList.add('active')
      }
    })
  }

  // 软件信息弹窗
  initModal () {
    this.softCardItems.forEach(item => {
      item.addEventListener('click', () => {
        // 找到兄弟元素
        const modal = item.nextElementSibling
        modal.classList.add('active')
      })
    })

    this.closeModalBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        this.closeModal()
      })
    })

    // 点击背景关闭模态框 SD__software-info-modal
    this.modals.forEach(modal => {
      modal.addEventListener('click', e => {
        if (e.target.classList.contains('SD__software-info-modal')) {
          this.closeModal()
        }
      })
    })

    this.parseHashParams()
  }

  // 关闭所有模态框
  closeModal () {
    this.modals.forEach(modal => {
      modal.classList.remove('active')
    })
  }

  // 移动端筛选按钮
  initFilterBtnMobile () {
    this.filterBtnMobile.addEventListener('click', () => {
      const filterWrapper = document.querySelector('.SD__left')
      if (filterWrapper.dataset.toogleStatusMb === 'close') {
        filterWrapper.dataset.toogleStatusMb = 'open'
      } else {
        filterWrapper.dataset.toogleStatusMb = 'close'
      }
    })

    this.filterBtnSubmenu.addEventListener('click', function () {
      const contentWrapper = this.closest('.SD__left-toggle-wrapper')
      console.log(
        `%c>> $contentWrapper`,
        'color:yellow',
        this.closest('.SD__left-toggle-wrapper')
      )
      if (contentWrapper.dataset.toogleStatusSubmenu === 'close') {
        contentWrapper.dataset.toogleStatusSubmenu = 'open'
      } else {
        contentWrapper.dataset.toogleStatusSubmenu = 'close'
      }
    })
  }

  // 监听 sticky-menu 给left 的高度赋值
  calcLeftStickyTop () {
    const stickyMenu = document.getElementById('sticky-menu')
    const stickyMenuRect = stickyMenu.getBoundingClientRect()
    const left = document.querySelector('.SD__left-wrapper')
    left.style.top = stickyMenuRect.top + stickyMenuRect.height + 16 + 'px'
  }
}

new SectionSoftwareDownload()
